import { IconPower, IconPuzzle } from '@tabler/icons-react'
import { useCallback, useEffect, useState } from 'react'
import { toast } from 'sonner'
import { getApi } from '../../../../api/call.api'
import { urlApi } from '../../../../api/url.api'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import { accessKeys } from '../../../../statics/accessKeys'
import { socketKeys } from '../../../../statics/socketKeys'
import { accessCheck } from '../../../../utils/accessCheck'
import VisitorDetailsSidebar from './VisitorDetailsSidebar'
import VisitorNoteSidebar from './VisitorNoteSidebar'
import ColorDropdown from './ColorDropdown'

const ChatHeader = ({ selectedUser, socket, page = "CHAT", callback, setSelectedUser }) => {

    const [colorList, setColorList] = useState([]);

    const onSessionEnd = useCallback(() => {
        let postData = {
            chatSessionId: selectedUser?._id
        }
        if (socket) {
            socket.emit(socketKeys.END_CHAT, postData);
        }
    }, [socket, selectedUser]);

    const getColorList = async () => {
        let resp = await getApi(urlApi.getChatHighlightColorList);
        if (resp?.responseCode === 200) {
            setColorList(resp?.data);
        } else {
            setColorList([]);
        }
    }

    useEffect(() => {
        getColorList();
        return () => { };
    }, []);

    const assignColor = async (e) => {
        let resp = await getApi(`${urlApi.assignColorForVisitor}${selectedUser?._id}/${e?._id}`);
        if (resp?.responseCode === 200) {
            callback?.();
            const currentColor = colorList.find(color => color._id === e?._id);
            setSelectedUser(currentColor?.colorCode);
            toast.success(resp?.message);
        } else {
            toast.error(resp?.message || "Failed to assign color.");
        }
    }

    const markUnresolved = async () => {
        let resp = await getApi(urlApi.markAsUnresolvedChat + selectedUser?._id);
        if (resp?.responseCode === 200) {
            callback?.();
            toast.success(resp?.message);
        } else {
            toast.error(resp?.message || "Failed to mark chat as unresolved.");
        }
    }

    return (
        <div className="flex items-center gap-2 p-2 bg-white rounded-lg shadow-sm">
            <div className='relative'>
                {selectedUser?.colorCode && <div className='h-4 w-4 rounded-full absolute -right-1 -top-1' style={{ backgroundColor: selectedUser?.colorCode }}></div>}
                <img src={selectedUser?.profilePic || "https://img.freepik.com/premium-vector/character-avatar-isolated_729149-194801.jpg"} alt="" className='w-10 h-10 rounded-full' />
            </div>
            <div className="flex flex-col gap-1">
                <p className='text-sm font-semibold'>{selectedUser?.visitorName} | #{selectedUser?.chatSessionCount}
                </p>
            </div>
            <div className="">
                <ColorDropdown
                    colorList={colorList}
                    selectedColorId={selectedUser?.colorCode}
                    onSelect={(color) => assignColor(color)}
                />
            </div>

            <div className='ms-auto flex items-center gap-2'>
                {accessCheck(accessKeys.createAndUpdateNote) && <VisitorNoteSidebar visitorData={selectedUser} />}
                <VisitorDetailsSidebar visitorData={selectedUser} />
                {page != "FEEDBACK" && selectedUser?.status != 5 && <ConfirmationModal buttonComponent={<IconPuzzle />} confirmationText={"Are you sure want to mark this chat as Unresolved?"} onConfirm={() => markUnresolved()} />}
                {((selectedUser?.status == 1 || selectedUser?.status == 2 || selectedUser.status == 5) && page != "FEEDBACK") && <ConfirmationModal buttonComponent={<IconPower />} confirmationText={"Are you sure want to close this chat?"} onConfirm={() => onSessionEnd()} />}
            </div>
        </div>
    )
}

export default ChatHeader